import { Component, Emit, Vue } from 'vue-property-decorator';
import './warning-message-modal.component.scss';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class WarningMessageModal extends Vue {
  @Prop() isShow!: boolean;
  @Prop() warningMsg!: string;

  /**
   * アクセプトボタンがクリックされたときに 'hideWarningMsgModal' イベントを発行します。
   *
   * @emits hideWarningMsgModal アクセプトボタンがクリックされたときに発行されるイベント
   */
  @Emit('hideWarningMsgModal')
  onClickAcceptBtn(): void {
    return;
  }

  render() {
    return (
      <b-modal
        v-model={this.isShow}
        id="warning-message-modal"
        modal-class="warning-message-modal"
        hide-footer
        hide-header
        centered
        no-close-on-backdrop={true}
        no-close-on-esc={true}
      >
        <div class="icon-container">
          <i class="material-icons">report</i>
        </div>
        <div class="text-container">
          <span class="warning-message">{this.warningMsg}</span>
        </div>
        <div class="btn-container">
          <button class="accept-btn" on-click={this.onClickAcceptBtn}>
            OK
          </button>
        </div>
      </b-modal>
    );
  }
}
